// The author-page href is shared — import { getAuthorPageUrl } from '@features/author'.
export const getCollectionPageUrl = ({
    authorUsername,
    slug,
}: {
    authorUsername: string
    slug: string
}): string => `/${authorUsername}/collections/${slug}`
